if (process.env.NODE_ENV === 'production') {
  __webpack_public_path__ = (window.gWebRoot || '') + process.env.VUE_APP_PATH.replace('[name]', process.env.VUE_APP_NAME) // eslint-disable-line
}
